export type NotificationCardType = 'feature' | 'info' | 'warning';

export class NotificationCard {
  id: string | null = null;
  title = '';
  description = '';
  imageUrl = '';
  cardType: NotificationCardType = 'feature';
  linkText = '';
  linkUrl = '';

  constructor(
    id: string | null,
    title: string,
    description: string,
    options?: {
      imageUrl?: string;
      linkText?: string;
      url?: string;
      color?: string;
    }
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    if (options) {
      if (typeof options.color === 'string') {
        switch (options.color) {
          case 'green':
          case 'feature':
            this.cardType = 'feature';
            break;
          case 'blue':
          case 'info':
            this.cardType = 'info';
            break;
          case 'warning':
          case 'red':
            this.cardType = 'warning';
            break;
          // no default
        }
      }

      this.imageUrl =
        typeof options.imageUrl === 'string' ? options.imageUrl : '';
      this.linkText =
        typeof options.linkText === 'string' ? options.linkText : '';
      this.linkUrl = typeof options.url === 'string' ? options.url : '';
    }
  }
}
